/**
 * Formats a raw number into a human-readable currency string with compact notation.
 * e.g., 2500000 -> "2.5M"
 * e.g., 500000 -> "500K"
 * e.g., 1000 -> "1K"
 */
export function formatCurrency(value: number | string | null | undefined): string {
    if (value === null || value === undefined || value === "") return "";

    // If it's already a formatted string containing letters (e.g. "2M", "500K", "EGP"), return as is.
    if (typeof value === 'string' && /[a-zA-Z]/.test(value)) {
        return value;
    }

    const num = typeof value === 'string' ? parseFloat(value.replace(/[^0-9.-]/g, '')) : value;
    if (isNaN(num)) return String(value);

    // Using Intl.NumberFormat for compact localized displays
    return new Intl.NumberFormat('en-US', {
        notation: "compact",
        maximumFractionDigits: 1
    }).format(num);
}

/**
 * Formats a raw number into a local-aware comma-separated string.
 * e.g., 2500000 -> "2,500,000"
 */
export function formatNumberWithCommas(value: number | string | null | undefined): string {
    if (value === null || value === undefined || value === "") return "";

    const num = typeof value === 'string' ? parseFloat(value.replace(/[^0-9.-]/g, '')) : value;
    if (isNaN(num)) return String(value);

    return new Intl.NumberFormat('en-US').format(num);
}
